export const OCR_INJECTION_KEY = Symbol('OCRContextKey')
export const OCR_HELPER_INJECTION_KEY = Symbol('OCRHelperContextKey')
